import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { identity } from 'ramda';

import { Container, MinusIcon, PlusIcon, Value } from './counter.styles';

export const Counter = ({ value, min, max, onUpdate }) => {
  const onMinusClick = useCallback(() => {
    const newValue = value <= min ? min : value - 1;

    onUpdate(newValue);
  }, [min, onUpdate, value]);

  const onPlusClick = useCallback(() => {
    const newValue = value >= max ? max : value + 1;

    onUpdate(newValue);
  }, [max, onUpdate, value]);

  return (
    <Container>
      <MinusIcon visible={value > min} onClick={onMinusClick} />
      <Value>{value}</Value>
      <PlusIcon visible={value < max} onClick={onPlusClick} />
    </Container>
  );
};

Counter.propTypes = {
  value: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  onUpdate: PropTypes.func,
};

Counter.defaultProps = {
  value: 0,
  min: 0,
  max: 99,
  onUpdate: identity,
};
